import React, { FC, useState } from 'react';
import cn from 'classnames/bind';

import { TracksList } from '@/scenarios/legacy-player/components/PlayerSkin/parts/AudioTracksList/AudioTracksList';
import { useAudioTracks } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/AudioTracks/useAudioTracks';
import { AudioTrack } from '@/scenarios/legacy-player/types/instance';

import styles from '../Tracks.module.css';

const cx = cn.bind(styles);

interface Props {
    onSelectAudioTrack: (track: AudioTrack) => void;
}

export const AudioTracks: FC<Props> = ({ onSelectAudioTrack }) => {
    const [isAllShown, setIsAllShown] = useState(false);

    const { currentTrack, soundTracks, handleSelectSoundTrack, hasInvisibleByDefaultTracks } =
        useAudioTracks({ isAllShown, onSelectAudioTrack });

    return (
        <TracksList
            className={cx('audio')}
            titleClassName={cx('title')}
            bodyClassName={cx('body')}
            currentAudioTrack={currentTrack}
            audioTracksWithNotes={soundTracks}
            handleSelectAudioTrack={handleSelectSoundTrack}
            isAllTracksVisible={isAllShown || !hasInvisibleByDefaultTracks}
            showAllTracks={() => setIsAllShown(true)}
        />
    );
};
